// extracted by mini-css-extract-plugin
export default {"canvas":"canvas-item_canvas_qeH85"};